import { render, staticRenderFns } from "./AttachmentFilesPreview.vue?vue&type=template&id=6002a728&scoped=true&"
import script from "./AttachmentFilesPreview.vue?vue&type=script&lang=ts&"
export * from "./AttachmentFilesPreview.vue?vue&type=script&lang=ts&"
import style0 from "./AttachmentFilesPreview.vue?vue&type=style&index=0&id=6002a728&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6002a728",
  null
  
)

export default component.exports